module.exports = __webpack_public_path__ + "static/ritz-cancun.19f633bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logos/ritz-cancun.png
// module id = 74
// module chunks = 168707334958949